
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import {
  getMarginTitle,
  getMarginMinTitle,
  isMarginUnitPercent,
} from "@/components/journals/config";

export default defineComponent({
  components: {
    CreateEditDialog,
    DecimalControl,
    TextControl,
    IntegerControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  computed: {
    volume(): any {
      return this.modelLocal.volume;
    },
    marginTitle(): any {
      return getMarginTitle();
    },
    marginMinTitle(): any {
      return getMarginMinTitle();
    },
    marginUnitInPercent(): any {
      return isMarginUnitPercent();
    },
  },
  watch: {
    volume(newVal) {
      // Глобальная переменная для расчета процентного соотношения
      window.globalThis.volume = newVal;
    },
  },

  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
      this.modelLocal = this.dialog().createEditModel;
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
    onShown(model: any) {
      (this as any).mountComponent(
        "components/journals/PlanOrderJournal/PlanOrderNomenclatureConstraintSubCatalogueGrid.vue",
        (this as any).nomenclatureConstraintSubGridDomId,
        {
          parentModel: model,
        }
      );
      (this as any).mountComponent(
        "components/journals/PlanOrderJournal/PlanOrderNomenclatureVolumeConstraintSubCatalogueGrid.vue",
        (this as any).nomenclatureVolumeConstraintSubGridDomId,
        {
          parentModel: model,
        }
      );
    },
    beforeUnmount() {
      (this as any).unmountComponent(
        (this as any).nomenclatureConstraintSubGridDomId
      );
      (this as any).unmountComponent(
        (this as any).nomenclatureVolumeConstraintSubGridDomId
      );
    },
  },
  data() {
    return {
      modelLocal: "",
      nomenclatureConstraintSubGridDomId:
        "PlanOrderNomenclatureCreateEditDialog_nomenclatureConstraintSubGridDomId",
      nomenclatureVolumeConstraintSubGridDomId:
        "PlanOrderNomenclatureCreateEditDialog_nomenclatureVolumeConstraintSubGridDomId",
    };
  },
});
